import script from "./SupplierSkuPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplierSkuPanel.vue?vue&type=script&setup=true&lang=js"

import "./SupplierSkuPanel.vue?vue&type=style&index=0&id=3be88402&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3be88402"]])

export default __exports__